import React, { useState, useEffect } from "react";
import { IoMdCart } from "react-icons/io";
import { useCart } from "../CartContext";
import { FaUserCircle } from "react-icons/fa";
import PhoneInput from "./PhoneInput";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { _get } from "../services/apiClient";

import { jwtDecode } from "jwt-decode";

function CartSection({
  size,
  loggedIn,
  setloggedIn,
  form,
  setForm,
  phoneNumber,
  setPhoneNumber,
  pageVisible,
  setPageVisible,
  ordersVisible,
  SetOrdersVisible,
  setCartVisible,
}) {
  const { totalPrice, resetTotalPrice } = useCart();
  const [isVerified, setIsVerified] = useState(false);
  const [name, setName] = useState(form.name || "");
  const [userId, setUserId] = useState(null);
  const navigate = useNavigate();
  const [showPlacedOrderSummary, setShowPlacedOrderSummary] = useState(false);


  useEffect(() => {
    const token = localStorage.getItem("token");
    if (!token) return;

    try {
      const decoded = jwtDecode(token);

      if (decoded?.id) {
        setloggedIn(true);
        setUserId(decoded.id);

        const fetchUserDetails = async () => {
          try {
            const res = await _get(`/auth/me/${decoded.id}`);
            if (res.data.success) {
              setName(res.data.user.name || "");
              setPhoneNumber(res.data.user.phoneNumber || "");
            }
          } catch (err) {
            console.error("Error fetching user:", err);
          }
        };

        fetchUserDetails();
      }
    } catch (err) {
      console.error("Invalid token:", err);
      setloggedIn(false);
    }
  }, [setloggedIn, setPhoneNumber]);





  const handleLogout = () => {
    localStorage.removeItem("token");
    localStorage.removeItem("user");
    setloggedIn(false);
    SetOrdersVisible(false);
    setPageVisible(false);

    localStorage.removeItem("cartValue");
    localStorage.removeItem("cartQuantityValue");
    resetTotalPrice();


    navigate("/");
    setTimeout(() => {
      window.location.reload();
    }, 100);
  };

  // const handleNext = () => {
  //   axios
  //     .post("http://localhost:3000/api/otp/getphoneno", {
  //       phoneNumber: phoneNumber || form.phoneNumber,
  //     })
  //     .then((response) => {
  //       if (response.data.success) {
  //         console.log("OTP Generated successful");
  //       } else {
  //         console.log("OTP Generated failed");
  //       }
  //     })
  //     .catch((error) => {
  //       console.error("Error sending data to server:", error);
  //     });

  //   setIsVerified(true);
  //   setPageVisible(false);
  // };

  return (
    <header
      className="section-header d-md-block d-block"
      style={{
        zIndex: 1500,
        background: "#0F4C5C",
        minHeight: "70px",
        padding: "10px 0",
      }}
    >
      <section className="header-main shadow-sm">
        <div className="container">
          {/* Flex Row for Logo + Icons */}
          <div className="d-flex justify-content-between align-items-center w-100">
            {/* Logo */}
            <div className="d-flex align-items-center">
              <a
                href="/"
                className="d-flex align-items-center"
                style={{
                  color: "white",
                  textDecoration: "none",
                  fontWeight: 600,
                  fontSize: "16px",
                  gap: "8px",
                }}
              >
                <img
                  src={window.location.origin + "/img/logo_web.png"}
                  alt="logo"
                  style={{
                    width: "30px",
                    height: "30px",
                    objectFit: "contain",
                  }}
                />
                <span>GoDigex Mart</span>
              </a>
            </div>

            {/* User + Cart */}
            <div
              className="d-flex align-items-center"
              style={{ gap: "10px" }}
            >
              {/* User Section */}
              <div className="text-center">
                <FaUserCircle
                  onClick={() => {
                    if (!loggedIn) {
                      navigate("/login");
                    }
                  }}
                  style={{
                    fontSize: "30px",
                    color: loggedIn ? "DarkCyan" : "darkred",
                    cursor: "pointer",
                  }}
                />

                {!loggedIn ? (
                  <div style={{ color: "orange", fontSize: "14px" }}>
                    Login
                  </div>
                ) : (
                  <div className="dropdown">
                    <a
                      href="#"
                      className="dropdown-toggle text-light d-block"
                      id="dropdownMenuButton"
                      data-toggle="dropdown"
                      aria-haspopup="true"
                      aria-expanded="false"
                      style={{ fontSize: "14px" }}
                    >
                      Hi {name}
                    </a>
                    <div
                      className="dropdown-menu dropdown-menu-right"
                      aria-labelledby="dropdownMenuButton"
                    >
                      <a
                        className="dropdown-item"
                        onClick={() => SetOrdersVisible(true)}
                      >
                        My Orders
                      </a>
                      <a className="dropdown-item" onClick={handleLogout}>
                        Logout
                      </a>
                    </div>
                  </div>
                )}
              </div>

              {/* Cart Section */}
              <div
                className="text-center"
                style={{ cursor: "pointer", marginLeft: "8px" }}
              >
                <div style={{ position: "relative" }}>
                  <IoMdCart
                    style={{ color: "Salmon", fontSize: "30px" }}
                    onClick={() => {
                      setCartVisible(true);
                      setShowPlacedOrderSummary(true);
                    }}
                  />
                  {/* Badge */}
                  <div
                    className="border rounded-pill bg-danger px-1 py-0 text-white shadow"
                    style={{
                      position: "absolute",
                      top: "-10px",
                      right: "-10px",
                      fontSize: "12px",
                    }}
                  >
                    {size}
                  </div>
                </div>
                <div style={{ color: "orange", fontSize: "14px" }}>My Cart</div>
              </div>
            </div>
          </div>

          {/* Login Popup */}
          <div>
            {!loggedIn && pageVisible && (
              <PhoneInput
                phoneNumber={phoneNumber}
                form={form}
                setloggedIn={setloggedIn}
                setForm={setForm}
                pageVisible={pageVisible}
                name={name}
                setName={setName}
                setPhoneNumber={setPhoneNumber}
                // handleNext={handleNext}
                setPageVisible={setPageVisible}
                isVerified={isVerified}
                setIsVerified={setIsVerified}
              />
            )}
          </div>
        </div>
      </section>
    </header>
  );
}

export default CartSection;
